export default __webpack_public_path__ + "static/media/Jain-spices.d9f624af.webp";